import { render } from "./Renovacion03FP.vue?vue&type=template&id=4fa82653&scoped=true"
import script from "./Renovacion03FP.vue?vue&type=script&lang=js"
export * from "./Renovacion03FP.vue?vue&type=script&lang=js"

import "@/assets/css/registro04FP.css?vue&type=style&index=0&id=4fa82653&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa82653"]])

export default __exports__